export default __webpack_public_path__ + "static/media/paper-plane-2x.8a4cc594.png";